import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";
//css & images
import "./App.css";
//components
import Navbar from "./Components/Navbar";
import Home from "./Views/Home";
import Footer from "./Components/Footer";
import { Toaster } from "./Components/Toaster";
import PhoneNumberVerification from "./Views/PhoneNumberVerification";
import WhatsappOnboarding from "./Views/WhatsappOnboarding";
import CheckStatus from "./Views/CheckStatus";
import DeprecatedOnboarding from "./Views/DeprecatedOnboarding";
import getCookieParam from "./Functions/getCookieParam";
import apiComponents from "./Functions/apiComponents";

const PortalLayout = () => (
  <>
    <Navbar />
    <header>
      <div
        className="heading-nav-div"
        style={{ cursor: "pointer" }}
        onClick={() => {
          window.location.pathname = `/${getCookieParam("partnerName")}`;
        }}
      >
        {window.location.pathname === `/${getCookieParam("partnerName")}`
          ? ""
          : "<< Home"}
      </div>
      <h1 className="primary-heading">
        Welcome! Let's create your WhatsApp account
      </h1>
      <div className="heading-nav-div"></div>
    </header>
    <div className="main-body">
      <Outlet />
    </div>
    <Footer />
    <Toaster />
  </>
);

const App = () => {

  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await fetch(apiComponents.pages);
        if (!response.ok) {
          throw new Error("Failed to fetch partners");
        }
        const data = await response.json();
        if (data.code === 1000 && data.data) {
          setPartners(data.data);
          apiComponents.setPartners(data.data);
        } 
        else {
          throw new Error("No partners found");
        }
        setLoading(false);
      }
      catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };


    fetchPartners();
  }, []);

  if (loading) return <div className="loading">Loading Partners...</div>;
  if (error) return <div className="error">Error: {error}</div>;

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PortalLayout />}>
          {/* global */}
          <Route path="/check-status" element={<CheckStatus />} />
          {/* Dynamic routes for each partner*/}
          {!loading &&
            partners.map((partner) => (
              <React.Fragment key={partner.partnerName}>
                <Route
                  exact
                  path={`/${partner.partnerName}`}
                  element={<Home />}
                />
                <Route
                  path={`/${partner.partnerName}/phone-number-verification`}
                  element={<PhoneNumberVerification />}
                />
                <Route
                  path={`/${partner.partnerName}/whatsapp-onboarding`}
                  element={<WhatsappOnboarding />}
                />
              </React.Fragment>
            ))}
        </Route>
        {/* redirects */}
        <Route exact path="/" element={<Navigate to="/engati" replace />} />
        <Route
          exact
          path="/engati/360dialog-setup"
          element={<Navigate to="/engati/whatsapp-onboarding" replace />}
        />
        <Route
          exact
          path="/wab/360dialog-setup"
          element={<Navigate to="/wab/whatsapp-onboarding" replace />}
        />
        <Route
          exact
          path="/wacto/360dialog-setup"
          element={<Navigate to="/wacto/whatsapp-onboarding" replace />}
        />
        <Route path="*" element={<DeprecatedOnboarding />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;

// import React, { useEffect, useState } from "react";
// import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
// import "./App.css";
// import Navbar from "./Components/Navbar";
// import Home from "./Views/Home";
// import Footer from "./Components/Footer";
// import { Toaster } from "./Components/Toaster";
// import PhoneNumberVerification from "./Views/PhoneNumberVerification";
// import WhatsappOnboarding from "./Views/WhatsappOnboarding";
// import CheckStatus from "./Views/CheckStatus";
// import getCookieParam from "./Functions/getCookieParam";
// import apiComponents from "./Functions/apiComponents";

// const App = () => {
//   const [partners, setPartners] = useState([]);

//   useEffect(() => {
//     fetch('/api/page') // Replace with the actual API endpoint URL
//       .then(response => {
//         // Adjust the following line based on the API response format
//         return response.json();  // Replace with appropriate parsing method
//       })
//       .then(data => {
//         // Adjust the following line to extract partner names from the response data
//         const partnerNames = data.partnerNames; // Assuming partner names are in a property called "partnerNames"
//         setPartners(partnerNames);
//       });
//   }, []);

//   if (!partnerNames.length) {
//     return <p>Loading...</p>;
//   }

//   const generateRoutes = () => {
//     return partnerNames.map((partner) => (
//       <React.Fragment key={partner.partnerName}>
//         <Route exact path={`/${partner.partnerName}`} element={<Home />} />
//         <Route path={`/${partner.partnerName}/phone-number-verification`} element={<PhoneNumberVerification />} />
//         <Route path={`/${partner.partnerName}/whatsapp-onboarding`} element={<WhatsappOnboarding />} />
//       </React.Fragment>
//     ));
//   };

//   return (
//     <>
//       <Navbar />
//       <header>
//         <div className="heading-nav-div" style={{ cursor: "pointer" }} onClick={() => { window.location.pathname = `/${getCookieParam('partnerName')}` }}>
//           {window.location.pathname === `/${getCookieParam('partnerName')}` ? '' : '<< Home'}
//         </div>
//         <h1 className="primary-heading">Welcome! Let's create your WhatsApp account</h1>
//         <div className="heading-nav-div"></div>
//       </header>
//       <div className="main-body">
//         <BrowserRouter>
//           <Routes>
//             <Route path="/check-status" element={<CheckStatus />} />
//             {partners.map(partner => {
//               <>
//                 <Route exact path={`/${partner.partnerName}`} element={<Home />} />
//                 <Route path={`/${partner.partnerName}/phone-number-verification`} element={<PhoneNumberVerification />} />
//                 <Route path={`/${partner.partnerName}/whatsapp-onboarding`} element={<WhatsappOnboarding />} />
//               </>
//             })}

//             {/* redirects */}
//             {/* <Route exact path="/" element={<Navigate to={`/${partnerNames[0].name || ''}`} replace />} /> */}
//             <Route exact path="/engati/360dialog-setup" element={<Navigate to="/engati/whatsapp-onboarding" replace />} />
//             <Route exact path="/wab/360dialog-setup" element={<Navigate to="/wab/whatsapp-onboarding" replace />} />
//             <Route exact path="/wacto/360dialog-setup" element={<Navigate to="/wacto/whatsapp-onboarding" replace />} />
//           </Routes>
//         </BrowserRouter>
//       </div>
//       <Footer />
//       <Toaster />
//     </>
//   );
// };

// export default App;
